import { combineReducers } from "redux";
import { reducer as getInformativesGeojson } from "./actions/getInformativesGeojson";

export const informativo = combineReducers({
  getInformativesGeojson
});
